/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if(document.querySelector('.noLazy')){
  function noLazyIsInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  
  function noLazyOnScroll() {
    const element = document.querySelector('.noLazy');
    if (noLazyIsInViewport(element)) {
        setTimeout(()=>{
                element.closest('.CollectionList ').querySelectorAll('.noLazy').forEach(laz=>laz.classList.remove('noLazy'))
          if(!document.querySelector('.noLazy')){
            window.removeEventListener('scroll', noLazyOnScroll);
          }
        }, 1000)
  
    }
  }
  
  window.addEventListener('scroll', noLazyOnScroll);
}

let lastKnownScrollPosition = 0;
let ticking = false;

function doSomething(scrollPos) {
  if(scrollPos >= 80){
    document.querySelector('#Search').classList.add('hide')
  }else{
    document.querySelector('#Search').classList.remove('hide')
  }
}

document.addEventListener('scroll', (e) => {
  lastKnownScrollPosition = window.scrollY;

  if (!ticking) {
    window.requestAnimationFrame(() => {
      doSomething(lastKnownScrollPosition);
      ticking = false;
    });

    ticking = true;
  }
});

//This code looks for the swym wishlist button, and if present, it moves them all to another location for more positioning control
openWishlistDrawer = (e)=>{
  if(document.querySelector('#sidebar-cart').getAttribute('aria-hidden') === 'true'){
    document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]').click()
  }
  document.querySelector('#sidebar-cart .cartDrawerTabLink[data-tab-index="2"]').click()
}
(function () {
  let swymButton = document.querySelector('.Header__Wrapper .swym-wishlist.swym-inject')
  const heartInterval = setInterval(()=>{
    if(swymButton){
      clearInterval(heartInterval)
      
      //This code moves the actual swym plugin to with the cart drawer for a more integrated experience:
      document.querySelector('#sidebar-cart .wishlist-widget-container').innerHTML = ''
      //document.querySelector('#sidebar-cart .wishlist-widget-container').appendChild(document.querySelector('#swym-plugin'))
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(function(swat) {
        var wishlistContainerElement = document.querySelector("#sidebar-cart .wishlist-widget-container");
        var queryParams = swat.utils.getEncodedAsObject(window.location.search);
        // Contains queryParams["lid"] to render a specific list id
        swat.ui.renderWishlistInContainer(wishlistContainerElement, queryParams);
      });
      //swymButton.click()
      swymButton.style.display = 'none';
      
      document.querySelectorAll('.ProductItem .swym-add-to-wishlist-view-product').forEach(button=>{
        button.parentElement.querySelector('.ProductItem__Info').appendChild(button)
      })
    }else{
      swymButton= document.querySelector('.Header__Wrapper .swym-wishlist.swym-inject')
    }
  }, 500)
})();

//This code moves the swym whishlist button on the pdp to a more favorible location:
(function () {
  if(document.querySelector('.Product__Info .ProductForm .ProductForm__BuyButtons')){
    let swymButton = document.querySelector('button.btn.swym-button')
    let ksChart = document.querySelector('.ks-chart-container')
    const heartInterval = setInterval(()=>{
      if(swymButton){
        clearInterval(heartInterval)
        if(!document.querySelector('.ProductForm__BuyButtons .buyBtnWrapper')){
          const buyBtnWrapper = document.createElement('div')
          buyBtnWrapper.classList.add('buyBtnWrapper')
          document.querySelector('.ProductForm__BuyButtons').insertBefore(buyBtnWrapper, document.querySelector('.ProductForm__BuyButtons > div'))
        }
        document.querySelector('.ProductForm__BuyButtons .buyBtnWrapper').appendChild(document.querySelector('.ProductForm__BuyButtons .ProductForm__AddToCart'))
        document.querySelector('.ProductForm__BuyButtons .buyBtnWrapper').appendChild(document.querySelector('.swym-button-bar.swym-wishlist-button-bar'))
      }else{
        swymButton= document.querySelector('button.btn.swym-button')
      }
    }, 500)

    const sizeChartInterval = setInterval(()=>{
      if(ksChart){
        clearInterval(sizeChartInterval)
        if(!document.querySelector('.ProductForm__BuyButtons .buyBtnWrapper')){
          const buyBtnWrapper = document.createElement('div')
          buyBtnWrapper.classList.add('buyBtnWrapper')
          document.querySelector('.ProductForm__BuyButtons').appendChild(buyBtnWrapper)
        }
         if(document.querySelector('.ProductForm__Option .SizeSwatchList')){
          document.querySelector('.ProductForm__Option .SizeSwatchList').parentElement.insertBefore(ksChart, document.querySelector('.ProductForm__Option .SizeSwatchList'))
        }
      }else{
        ksChart = document.querySelector('.ks-chart-container')
      }
    },500);
    

    let webyzAvailable = document.querySelector('.Product__Info .ProductForm .swatchProductColor')
    const webyzInterval = setInterval(()=>{
      if(webyzAvailable){
        clearInterval(webyzInterval)
        document.querySelectorAll('.Product__Info .ProductForm .swatchProductColor').forEach(async (colorSwatch, index) => {
          await fetch('/products/' + colorSwatch.getAttribute('data-handle') + '.js')
          .then(response=>{
              if(response.ok){
                  return response.json()
              }else{
                  if(response.status === 404)
                      throw new Error('Product Not Found')
                  else
                      throw new Error('Something Went Wrong')
              }
          })
          .then(data=>{
            if(data.available != true){
                
              colorSwatch.classList.add('notAvailable')
              colorSwatch.classList.add('color--unavailable')
            }
          })
          .catch(error=>{
              colorSwatch.classList.add('notAvailable')
              colorSwatch.classList.add('color--unavailable')
          })
        })
      }else{
        webyzAvailable= document.querySelector('.Product__Info .ProductForm .swatchProductColor')
      }
    }, 500)
  }



  //Braided Products' Pop Up Code:
  const closeMakeYourOwnModal = e => {
    e.preventDefault()
    document.querySelector('.makeYourOwnModal').classList.remove('is-visible')
    document.querySelector('.PageOverlay').classList.remove('is-visible')
    document.querySelector('html').classList.remove('no-scroll')
    setTimeout(()=>{
      document.querySelector('.makeYourOwnModal').style.display = 'none'
    }, 500)
     document.querySelector('.PageOverlay').removeEventListener('click', closeMakeYourOwnModal)
  }

  document.querySelectorAll('.makeYourOwnBtn')?.forEach(btn=>{
    btn.addEventListener('click', e=>{
      e.preventDefault()
      document.querySelector('.PageOverlay').classList.add('is-visible')
      document.querySelector('.makeYourOwnModal').style.display = 'block'
      document.querySelector('html').classList.add('no-scroll')
      setTimeout(()=>{
        document.querySelector('.makeYourOwnModal').classList.add('is-visible')
        document.querySelector('.PageOverlay').addEventListener('click', closeMakeYourOwnModal)
        document.querySelector('.makeYourOwnModal .closeMakeYourOwnModal').addEventListener('click', closeMakeYourOwnModal)
      }, 500)
    })
  })
  
  if(document.querySelector('.Product')){
   let webyzeContainer = document.querySelector('.webyzeProductColors')
    const awaitSwatch = setInterval (()=>{
        if (webyzeContainer) {
            clearInterval(awaitSwatch)
            let presentSwatchesInModal = 0
            if(document.querySelector(`.makeYourOwnModal`)){
            webyzeContainer.querySelectorAll('.swatchProductColor').forEach(swatch=>{
                const swatchColor = swatch.getAttribute('title').split(' - ')[1]?.toLowerCase().replace(' ', '-')
                if(swatchColor){
                const swatchImageLink = document.querySelector(`.makeYourOwnModal a[data-value="${swatchColor}"]`)
                if(swatchImageLink){
                    presentSwatchesInModal++;
                    swatchImageLink.classList.add('is-visible')
                    swatchImageLink.addEventListener('click', async e=>{
                        e.preventDefault()
                        const handle = swatch.getAttribute('data-handle')
                        document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
                        let formData = {
                            items: []
                        }
                        jQuery.getJSON(window.Shopify.routes.root + `products/${handle}`, function({product}) {
                            
                            formData.items.push({
                                id: product.variants[0].id,
                                quantity: 1
                            })
    
                                                fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(formData),
                            credentials: 'same-origin',
                            method: 'POST',
                            headers: {
                              'Content-Type': 'application/json',
                              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                      
                            }
                          }).then(function(response){
                            document.dispatchEvent(new CustomEvent('theme:loading:end'))
                            if (response.ok) {
    document.querySelector('.makeYourOwnModal .closeMakeYourOwnModal').click();
             document.dispatchEvent(new CustomEvent('product:added', {
                                bubbles: true,
                                detail: {
                                  variant: product.variants[0].id,
                                  quantity: 1
                                }
                              }));
                            }else{
                              alert('Something Went Wrong')
                            }
                          })
                        });
                    })
    
                }
                }
            })
            }
            if(presentSwatchesInModal==0){
                const makeYourOwnBtn = document.querySelector('.makeYourOwnBtn')
                if(makeYourOwnBtn){
                  makeYourOwnBtn.parentElement.removeChild(makeYourOwnBtn)
                }
            }
          
            // Code to add color label when a color is chosen:
            let productColor = webyzeContainer.querySelector('.swatchProductColor.currentSwatch').getAttribute('data-name')
            productColor = typeof productColor.split('-')[1] != 'undefined' ? productColor.split('-')[1] : productColor.split(' - ')[1]
            const colorLabel = document.createElement('span')
            colorLabel.className = 'ProductForm__SelectedValue'
            if (typeof productColor != 'undefined')
              colorLabel.innerText = productColor
            else
              colorLabel.innerText = ''
              
            webyzeContainer.parentElement.insertBefore(colorLabel,webyzeContainer)
        }else{
            webyzeContainer = document.querySelector('.webyzeProductColors')
        }
    }, 500) 
  }
  else if(document.querySelector('.makeYourOwnModal')){
    document.querySelector('.makeYourOwnModal').classList.add('showAllLinks')
    document.querySelectorAll('.makeYourOwnModal a').forEach(link=>{
      link.addEventListener('click', e=>e.preventDefault())
    })
  }
  
window.webyzeMultiProductColorsLoad()
document.querySelectorAll(".ProductItem.splideEnabledItem:not(.offLimits)").forEach((productItem)=>window.productItemSetup(productItem));

})();


if(document.querySelector('.ProductMeta')){
  let checkAfterPay =  ()=> {
    if(!document.querySelector('afterpay-placement')){
      setTimeout(checkAfterPay, 100);
     }else{
        if(document.querySelector('body.splitTestPDP')){
         document.querySelector('.ProductMeta').appendChild(document.querySelector('afterpay-placement'))
          document.querySelector('.ProductMeta afterpay-placement').shadowRoot.querySelector(' .afterpay-paragraph').classList.add('active-afterpay')
          let style = document.createElement("style");
        
          style.textContent = `
            p.afterpay-paragraph{
              font-family: Poppins;
              font-size: 10px;
              font-weight: 400;
              line-height: 15px;
              letter-spacing: 0.08em;
              text-align: left;
            }`;
            document.querySelector('.ProductMeta afterpay-placement').shadow.appendChild(style)
        }else{
          document.querySelector('.ProductMeta .ProductMeta__PriceList').appendChild(document.querySelector('afterpay-placement'))
          document.querySelector('.ProductMeta .ProductMeta__PriceList .afterpay-paragraph').classList.add('active-afterpay')
        }
    }
   }
  checkAfterPay();
}
/*
if(document.querySelector('.ColorSwatchList')){
  const stapleColorsDiv = document.createElement('div')
  stapleColorsDiv.className = 'ProductForm__Option ProductForm__Option--labelled'
  const labelSpan = document.createElement('span')
  labelSpan.className = 'ProductForm__Label'
  labelSpan.innerText = 'Staple Colors:'
  const stapleColorsList = document.createElement('div')
  
  document.querySelectorAll('.ColorSwatchList .ColorSwatch').forEach(swatch=>{
    
  })
}*/

if(document.querySelectorAll('.SeasonalColorsOptions, StapleColorsOptions').length){
  (function () {
    document.querySelectorAll('.SeasonalColorsOptions input.ColorSwatch__Radio, .StapleColorsOptions input.ColorSwatch__Radio').forEach(colorSwatch=>{
      colorSwatch.addEventListener('change', e=>{
        if(colorSwatch.checked){
          if(colorSwatch.closest('.SeasonalColorsOptions')){
            document.querySelector('.StapleColorsOptions .ProductForm__Label .ProductForm__SelectedValue').innerText = ''
          }else if(colorSwatch.closest('.StapleColorsOptions')){
            document.querySelector('.SeasonalColorsOptions .ProductForm__Label .ProductForm__SelectedValue').innerText = ''
          }
        }
      })
    })
  })();
}

let drawerTabAnimationOnGoing = false;
document.querySelectorAll('.Drawer__Header .cartDrawerTabLink').forEach(tab=>{
  const sideBarCart = document.querySelector('#sidebar-cart')
  tab.addEventListener('click', e=>{
    if(tab.classList.contains('currentActiveTabLink') || drawerTabAnimationOnGoing)
      return true
    drawerTabAnimationOnGoing = true;
    tab.parentElement.querySelector('.currentActiveTabLink').classList.remove('currentActiveTabLink')
    tab.classList.add('currentActiveTabLink')
    const currentActiveTab = sideBarCart.querySelector(`.cartDrawerTab.currentActiveTab`)
    const newActiveTab = sideBarCart.querySelector(`.cartDrawerTab[data-tab-index="${tab.getAttribute('data-tab-index')}"]`)
    currentActiveTab.classList.remove('currentActiveTab')
    setTimeout(()=>{
      currentActiveTab.style.display = 'none'
      newActiveTab.style.display = 'flex'
      setTimeout(()=>{
        newActiveTab.classList.add('currentActiveTab')
        drawerTabAnimationOnGoing = false;
      },100)
    },500)
  })
})

